module.exports = "/assets/data/6f900de7beb4019a8594e518f098abda-KA23.data.json";